import { useTranslation } from 'react-i18next';

/** Intrinsic size of the served asset (2x the 40 px display height); reserves the space before it loads. */
const LOGO_WIDTH = 324;
const LOGO_HEIGHT = 80;

/**
 * The Social Studio logo, mark and wordmark (style guide 2.51). The alt is the
 * product name from the locales: inside the home link it is the link's name.
 * The display height comes from CSS (`ui-brand__logo`), per placement.
 */
export function BrandLogo() {
  const { t } = useTranslation();
  return (
    <img
      className="ui-brand__logo"
      src="/brand/social-studio-logo.png"
      alt={t('shell.brand')}
      width={LOGO_WIDTH}
      height={LOGO_HEIGHT}
      decoding="async"
    />
  );
}
